import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import Api from "../Services/Api";
import "./Login.css";

const FALLBACK_BANNERS = [
  {
    id: "fallback-1",
    url: "/Banner-Inicial.jpg",
    mobileUrl: "/Banner-Inicial-Mobile.jpg",
    alt: "Banner inicial Smart Olfativos",
  },
  {
    id: "fallback-2",
    url: "/Banner-Inicial-02.jpg",
    mobileUrl: "/Banner-Inicial-Mobile.jpg",
    alt: "Banner promocional Smart Olfativos",
  },
];

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [banners, setBanners] = useState(FALLBACK_BANNERS);
  const [activeBanner, setActiveBanner] = useState(0);

  const handleBannerError = (bannerId) => {
    setBanners((current) => {
      const next = current.filter((banner) => banner.id !== bannerId);
      return next.length > 0 ? next : FALLBACK_BANNERS;
    });
  };

  useEffect(() => {
    let mounted = true;

    const loadBanners = async () => {
      try {
        const response = await Api.get("/public/login-banners");
        const items = Array.isArray(response?.data?.items) ? response.data.items : [];

        if (!mounted || items.length === 0) return;

        setBanners(
          items.map((item, index) => ({
            id: item.id || `banner-${index}`,
            url: item.url,
            alt: item.originalName || `Banner ${index + 1}`,
          }))
        );
      } catch (err) {
        console.error("Erro ao carregar banners do login:", err);
      }
    };

    loadBanners();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    setActiveBanner(0);
  }, [banners]);

  useEffect(() => {
    if (banners.length <= 1) return undefined;

    const interval = window.setInterval(() => {
      setActiveBanner((current) => (current + 1) % banners.length);
    }, 5000);

    return () => window.clearInterval(interval);
  }, [banners]);

  const clickLogin = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const email = String(formData.get("email") || "").trim();
    const senha = String(formData.get("password") || "");

    if (!email || !senha) {
      alert("Preencha e-mail e senha.");
      return;
    }

    try {
      const response = await Api.post("/auth/login", {
        email,
        password: senha,
      });

      if (response.data.ok) {
        login(response.data.user);
        navigate(response.data.redirect);
      }
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Falha no login");
    }
  };

  return (
    <div className="login-page">
      <header className="login-topbar">
        <div className="login-brand">
          <img src="/logo-horizontal.png" alt="Logo Smart Olfativos" />
        </div>

        <form className="topbar-login-form" onSubmit={clickLogin}>
          <label className="sr-only" htmlFor="email">
            E-mail
          </label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="E-mail"
            autoComplete="username"
            required
          />

          <label className="sr-only" htmlFor="password">
            Senha
          </label>
          <input
            id="password"
            name="password"
            type="password"
            placeholder="Senha"
            autoComplete="current-password"
            required
          />

          <button type="submit">Entrar</button>
        </form>
      </header>

      <main className="login-banner">
        <div className="login-carousel" role="region" aria-label="Carrossel de banners">
          {banners.map((banner, index) => (
            <picture
              key={banner.id}
              className={`banner-slide ${index === activeBanner ? "is-active" : ""}`}
            >
              {banner.mobileUrl ? (
                <source srcSet={banner.mobileUrl} media="(max-width: 768px)" />
              ) : null}
              <img
                src={banner.url}
                alt={banner.alt}
                onError={() => handleBannerError(banner.id)}
              />
            </picture>
          ))}

          {banners.length > 1 ? (
            <div className="login-carousel-dots" aria-label="Selecionar banner">
              {banners.map((banner, index) => (
                <button
                  key={`dot-${banner.id}`}
                  type="button"
                  className={index === activeBanner ? "is-active" : ""}
                  aria-label={`Exibir banner ${index + 1}`}
                  onClick={() => setActiveBanner(index)}
                />
              ))}
            </div>
          ) : null}
        </div>
      </main>
    </div>
  );
};

export default Login;
